export default function IconTik() {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.40723" y="5.4043" width="5.68421" height="1.89474" rx="0.947368" transform="rotate(45 1.40723 5.4043)" fill="white"/>
      <rect x="2.77637" y="9.58789" width="9.47485" height="1.89214" rx="0.946069" transform="rotate(-51.9436 2.77637 9.58789)" fill="white"/>
    </svg>
  );
}
